export enum WaistlistRequestStatus {
    SUCCESS,
    NOT_FOUND,
    RATE_LIMITED,
    ERROR,
}
